/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useEffect, useState } from "react";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function PerformAccountingAudits() {
	const { currentStep, countryBrandApplication, update, formRef, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const { accountingAuditsValue, accountingAuditsCompanyName } = countryBrandApplication;
	const [audits, setAudits] = useState(!accountingAuditsValue || accountingAuditsValue === "Si");

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		function submitStepData() {
			const formElement = formRef.current as HTMLFormElement;
			const accountingAuditsValue = formElement.elements.accountingAuditsValue.value;
			const accountingAuditsCompanyName =
				formElement.elements.accountingAuditsCompanyName?.value ?? "";
			update({
				data: {
					accountingAuditsValue,
					accountingAuditsCompanyName,
				},
				nextStep: currentStep + 1,
			});
		}
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, []);

	const handelChange = () => {
		formRef.current.elements.accountingAuditsValue.value === "Si"
			? setAudits(true)
			: setAudits(false);
	};

	return (
		<div className="step-page" id="step-10">
			<section>
				<h3>10 - ¿Realiza periódicamente su organización auditorías contables?</h3>
				<select
					name="accountingAuditsValue"
					id="accountingAuditsValue"
					defaultValue={accountingAuditsValue}
					onChange={handelChange}
				>
					<option value="Si">Si</option>
					<option value="No">No</option>
				</select>
				{audits && (
					<label htmlFor="accountingAuditsCompanyName">
						Empresa Auditora *
						<input
							type="text"
							name="accountingAuditsCompanyName"
							id="accountingAuditsCompanyName"
							required
							defaultValue={accountingAuditsCompanyName}
						/>
					</label>
				)}
			</section>
		</div>
	);
}

export { PerformAccountingAudits };
